<template>
  <div>
  <!-- <div class="container"> -->
    <div class="cards-1 row px-3 justify-content-center">
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-5">
          <div class="card-body">
            <div class="justify-content-center">
              <div class="card-icon mx-auto blue">
                <span class="far fa-file-alt"></span>
              </div>
              <h5 class="card-title text-center mt-1 mt-lg-0 mx-2">
                اقتصادی
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul class="list-unstyled li-space-lg col-6 col-sm-3 col-md-3 col-lg-7 col-xl-6">
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-check"></i>
                    <div class="flex-grow-1">گالری عکس</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-check"></i>
                    <div class="flex-grow-1">اطلاعات تماس</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-times mx-1"></i>
                    <div class="flex-grow-1">پنل مدیریت</div>
                  </div>
                </li>
                <li class="">
                  <div class="d-flex">
                    <i class="fas fa-times mx-1"></i>
                    <div class="flex-grow-1">درگاه پرداخت</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-5">
          <div class="card-body">
            <div class="justify-content-center">
              <div class="card-icon mx-auto red">
                <span class="fas fa-gift"></span>
              </div>
              <h5 class="card-title text-center  mt-1 mt-lg-0 mx-2">
              ویژه
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul class="list-unstyled li-space-lg col-6 col-sm-3 col-md-3 col-lg-7 col-xl-6">
              <li class="">
                 <div class="d-flex ">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">فروشگاه آنلاین</div>
                  </div>             
                </li>
                                
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">درگاه پرداخت</div>
                  </div>             
                </li>
                               
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">پنل مدیریت</div>
                  </div>             
                </li>
                               
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">گزارش دوره ای</div>
                  </div>             
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xxl-3 mb-2">
        <div class="card py-3 px-5 px-xs-4 pe-sm-2 ps-sm-4 px-md-5 px-xl-5">
          <div class="card-body">
            <div class="justify-content-center">
              <div class="card-icon mx-auto yellow">
                <span class="fas fa-solar-panel"></span>
              </div>
              <h5 class="card-title text-center  mt-1 mt-lg-0 mx-2">
              سفارشی
              </h5>
            </div>
            <div class="row justify-content-center">
              <ul class="list-unstyled li-space-lg col-6 col-sm-3 col-md-3 col-lg-7 col-xl-6">
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">سایت شرکتی</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">فرم استخدام</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">پنل مدیریت</div>
                  </div>
                  </li>
                <li class="">
                  <div class="d-flex">
                  <i class="fas fa-check"></i>
                  <div class="flex-grow-1">سفارش شما</div>
                  </div>
                  </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- </div> -->
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>